import { Component, ChangeDetectionStrategy } from '@angular/core';
import { GridFilterBaseComponent } from '../grid-filter-base-component';
import { ControlContainer, NgForm, FormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';

import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'sn-boolean-grid-filter',
    templateUrl: './boolean-grid-filter.component.html',
    styleUrls: ['./boolean-grid-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [MatFormFieldModule, MatSelectModule, MatOptionModule, FormsModule]
})
export class BooleanGridFilterComponent extends GridFilterBaseComponent {

  constructor() {
    super();
  }
}
